<template>
    <tr
      @keydown.esc="$emit('cancel')"
    >
        <td>
            <v-autocomplete
                v-model="selectedArticle"
                :items="articles"
                label="Izberi artikel"
                item-text="name"
                ref="name"
                auto-select-first
                return-object
                @keydown.native="keydownAutocomplete"
                @focus="focusAutocomplete"
            ></v-autocomplete>
        </td>
        <td>
            <v-text-field
                v-model="quantity"
                ref="quantity"
                label="Vnesi količino"
                @keydown.enter="parseQuantityInput(); save()"
                @keydown.tab.prevent="parseQuantityInput(); save()"
                @focus="$event.target.select()"
            ></v-text-field>
        </td>
        <td>{{purchase_measurement_unit}}</td>
        <td>
            <ButtonActionSave @click="save" />
            <ButtonActionCloseEditing @click="$emit('cancel')" />
        </td>
    </tr>
</template>

<script>
import ButtonActionSave from '@/components/ButtonActionSave'
import ButtonActionCloseEditing from '@/components/ButtonActionCloseEditing'
import { parseSiFloat } from '@/utils/number'

export default {
  components: {
    ButtonActionSave,
    ButtonActionCloseEditing
  },
  props: {
    article: {
      default: () => {},
      type: Object
    },
    articles: {
      required: true,
      type: Array
    }
  },
  data () {
    return {
      selectedArticle: null,
      quantity: null
    }
  },
  computed: {
    isNewArticle () {
      return this.article ? Object.keys(this.article).length === 0 || !this.article.article : true
    },
    purchase_measurement_unit () {
      return this.selectedArticle ? this.selectedArticle.purchase_measurement_unit_name : ''
    }
  },
  methods: {
    setCurrentRowData (article) {
      this.quantity = article ? article.quantity : null
    },
    goTo (refName) {
      this.$refs[refName].focus()
    },
    save () {
      this.parseAllInputs()
      const saveItem = {
        article: this.selectedArticle.id,
        quantity: this.quantity
      }
      const event = this.isNewArticle ? 'save' : 'update'
      this.$emit(event, saveItem)
    },
    parseAllInputs () {
      this.parseQuantityInput()
    },
    parseQuantityInput () {
      if (!this.quantity) this.quantity = 0
      this.quantity = parseSiFloat(this.quantity)
    },
    focusAutocomplete ($event) {
      this.$nextTick(() => {
        this.$nextTick(() => {
          $event.target.select()
        })
      })
    },
    keydownAutocomplete ($event) {
      if ($event.code === 'Enter') {
        this.goTo('quantity')
      }
    }
  },
  mounted () {
    if (!this.isNewArticle) {
      this.setCurrentRowData(this.article)
      this.selectedArticle = this.articles.find(article => article.id === this.article.article)
    }
    this.$refs.name.focus()
  }
}
</script>
